import React from 'react';
import clsx from 'clsx';

import styles from './ProbabilityBar.module.scss';
import MinBorrowerLine from '../../../../assets/Svg/MinBorrowerLine';

interface ProbabilityBarProps {
    probability: string;
    pecThreshold?: string;
}

function ProbabilityBar({ probability = '0', pecThreshold }: ProbabilityBarProps) {
    // Parse and validate probability
    let probabilityValueForBar = parseFloat(probability);
    probabilityValueForBar = Number.isNaN(probabilityValueForBar) ? 0 : probabilityValueForBar;
    // Clamp to 0-100 range
    probabilityValueForBar = Math.max(0, Math.min(100, probabilityValueForBar));

    // Parse and validate pecThreshold
    let pecThresholdValue: number | undefined = undefined;
    if (pecThreshold) {
        const parsedThreshold = parseFloat(pecThreshold);
        pecThresholdValue = Number.isNaN(parsedThreshold) ? undefined : parsedThreshold;
    }

    // Check if probability is below threshold
    const isBelowThreshold = pecThresholdValue !== undefined && probabilityValueForBar < pecThresholdValue;

    const displayValue = probabilityValueForBar <= 0 ? 'N/A' : `${probabilityValueForBar}%`;

    return (
        <div className={styles.Probability}>
            <div
                className={clsx(styles.Value, {
                    [styles.NotAvailable]: probabilityValueForBar <= 0,
                    [styles.BelowThreshold]: isBelowThreshold,
                })}
            >
                {displayValue}
            </div>

            <div className={styles.BarContainer}>
                <div
                    className={clsx(styles.BarFill, {
                        [styles.BelowThreshold]: isBelowThreshold,
                    })}
                    style={{ width: `${probabilityValueForBar}%` }}
                />
                {pecThresholdValue !== undefined && (
                    <div className={styles.MinBorrowerLine} style={{ left: `${pecThresholdValue}%` }}>
                        <MinBorrowerLine height="24" width="3" colour="#000000" />
                    </div>
                )}
            </div>
        </div>
    );
}

export default ProbabilityBar;
